import React from "react";
import "./Header.css";
import SearchIcon from "@material-ui/icons/Search";
import ShoppingCartIcon from "@material-ui/icons/ShoppingCart";
import { Link } from "react-router-dom";
//import { useStateValue } from "./StateProvider";
import { auth } from "./firebase";
import { useSelector } from "react-redux";
import { selectUser } from "./redux/cart/cartSlice";

function Header() {
  console.log("Enter Header Page");
  //const [{ basket, user }, dispatch] = useStateValue();
  const { user, basket } = useSelector(selectUser);

  const handleAuthentication = () => {
    //sessionStorage.setItem("test", state.user?.email + " id");
    if (user) {
      console.log("going to logout");
      auth.signOut();
    }
  };
  console.log("User in Header Page", user);
  return (
    <div className="header">
      <Link to="/">
        <img
          className="header__logo"
          src="http://pngimg.com/uploads/amazon/amazon_PNG11.png"
          alt="amazon logo"
        />
      </Link>
      <form className="header__search">
        <div className="header__selectDropdown">
          <select>
            <option select="selected" value="search-alias=aps">
              All
            </option>
            <option value="search-alias=todays-deals">Deals</option>
            <option value="search-alias=alexa-skills">Alexa Skills</option>
            <option value="search-alias=amazon-devices">Amazon Devices</option>
            <option value="search-alias=fashion">Amazon Fashion</option>
            <option value="search-alias=nowstore">Amazon Fresh</option>
            <option value="search-alias=pantry">Amazon Pantry</option>
            <option value="search-alias=appliances">Appliances</option>
            <option value="search-alias=mobile-apps">Apps &amp; Games</option>
            <option value="search-alias=baby">Baby</option>
            <option value="search-alias=beauty">Beauty</option>
            <option value="search-alias=stripbooks">Books</option>
            <option value="search-alias=automotive">Car &amp; Motorbike</option>
            <option value="search-alias=apparel">
              Clothing &amp; Accessories
            </option>
            <option value="search-alias=collectibles">Collectibles</option>
            <option value="search-alias=computers">
              Computers &amp; Accessories
            </option>
            <option value="search-alias=electronics">Electronics</option>
            <option value="search-alias=furniture">Furniture</option>
            <option value="search-alias=lawngarden">
              Garden &amp; Outdoors
            </option>
            <option value="search-alias=gift-cards">Gift Cards</option>
            <option value="search-alias=grocery">
              Grocery &amp; Gourmet Foods
            </option>
            <option value="search-alias=hpc">Health &amp; Personal Care</option>
            <option value="search-alias=kitchen">Home &amp; Kitchen</option>
            <option value="search-alias=industrial">
              Industrial &amp; Scientific
            </option>
            <option value="search-alias=jewelry">Jewellery</option>
            <option value="search-alias=digital-text">Kindle Store</option>
            <option value="search-alias=luggage">Luggage &amp; Bags</option>
            <option value="search-alias=luxury-beauty">Luxury Beauty</option>
            <option value="search-alias=dvd">Movies &amp; TV Shows</option>
            <option value="search-alias=popular">Music</option>
            <option value="search-alias=mi">Musical Instruments</option>
            <option value="search-alias=office-products">
              Office Products
            </option>
            <option value="search-alias=pets">Pet Supplies</option>
            <option value="search-alias=instant-video">Prime Video</option>
            <option value="search-alias=shoes">Shoes &amp; Handbags</option>
            <option value="search-alias=software">Software</option>
            <option value="search-alias=sporting">
              Sports, Fitness &amp; Outdoors
            </option>
            <option value="search-alias=home-improvement">
              Tools &amp; Home Improvement
            </option>
            <option value="search-alias=toys">Toys &amp; Games</option>
            <option value="search-alias=under-ten-dollars">Under ₹500</option>
            <option value="search-alias=videogames">Video Games</option>
            <option value="search-alias=watches">Watches</option>
          </select>
        </div>
        <input className="header__searchInput" type="text" />
        <SearchIcon className="header__searchIcon" />
      </form>
      <div className="header__nav">
        <Link to={!user && "/login"}>
          {/*if not user then only send to login page*/}
          <div onClick={handleAuthentication} className="header__option">
            <span className="header__optionLineOne">
              Hello, {!user ? "Guest" : user?.email}
            </span>
            <span className="header__optionLineTwo">
              {user ? "Sign Out" : "Sign In"}
            </span>
          </div>
        </Link>
        <Link to="/orders">
          <div className="header__option">
            <span className="header__optionLineOne">Returns</span>
            <span className="header__optionLineTwo">& Orders</span>
          </div>
        </Link>
        <div className="header__option">
          <span className="header__optionLineOne">Your</span>
          <span className="header__optionLineTwo">Prime</span>
        </div>
        <Link to="/checkout">
          <div className="header__optionBasket">
            <ShoppingCartIcon className="header__optionBasketIcon" />
            <span
              className="header__optionLineTwo 
            header__basketCount"
            >
              {basket?.length}
            </span>
          </div>
        </Link>
      </div>
    </div>
  );
}

export default Header;
